export interface IEditData<T> {
    id: string;
    payload: T;
}
